import { render, staticRenderFns } from "./configurator-uv-configurations.modal.vue?vue&type=template&id=25c40df9&"
import script from "./configurator-uv-configurations.modal.vue?vue&type=script&lang=ts&"
export * from "./configurator-uv-configurations.modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports